import ImportTaxeAutoForm from '../components/ImportTaxeAutoForm';
import useNewGiveaway from './useNewGiveaway';

export default function CityTaxeAutoImport() {
    const {
        handleSubmit,
        createdGiveaway
    } = useNewGiveaway();

    return (
        <ImportTaxeAutoForm onSubmit={handleSubmit} createdGiveaway={createdGiveaway} />
    )
}
